import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { skip, takeUntil } from 'rxjs/operators';
import * as reducers from '@app/reducers';
import { loadUsernames } from '@app/history/history.actions';

@Component({
  selector: 'app-username-selector',
  template: `
    <div ngbDropdown class="d-inline-block role-dropdown">
      <label for="role" class="label-text" *ngIf="isLabelVisible"
        >Username</label
      >
      <button
        class="btn btn-dropdown dark-text role-width"
        id="dropdownCategory"
        ngbDropdownToggle
      >
        {{ selectedUsername }}
        <i class="icon icon-down-arrow"></i>
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdownCategory"
        class="dropdownMenu"
      >
        <div class="dropdown-search">
          <input
            type="text"
            class="form-control"
            placeholder="Search..."
            [(ngModel)]="searchTerm"
            (input)="filterUsernames()"
          />
        </div>
        <ng-container *ngFor="let username of filteredUsernames">
          <button
            ngbDropdownItem
            [disabled]="disabled"
            class="dropdown-item dropdown-value"
            (click)="onUsernameChange(username)"
            *ngIf="selectedUsername !== username"
          >
            <div class="dropdown-text">
              {{ username }}
            </div>
          </button>
        </ng-container>
      </div>
    </div>
  `,
  styles: [],
})
export class UsernameSelectorComponent implements OnInit {
  @Output() usernameChange = new EventEmitter();
  @Input() isLabelVisible = false;
  @Input() disabled = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  allUsernames = ['All usernames'];
  usernames = this.allUsernames;
  @Input() selectedUsername = this.usernames[0];

  searchTerm: string = '';
  filteredUsernames: string[] = [];

  constructor(private store: Store<reducers.State>) {}

  ngOnInit() {
    this.store.dispatch(loadUsernames.init({ payload: { category: 'email' } }));
    this.store
      .select(reducers.getUsernames)
      .pipe(takeUntil(this.destroy$), skip(1))
      .subscribe((list: string[]) => {
        this.usernames = this.allUsernames.concat(list);
      });
  }

  filterUsernames() {
    this.filteredUsernames = this.usernames.filter((username) =>
      username.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  onUsernameChange(username: string) {
    this.selectedUsername = username;
    if (username === this.allUsernames[0]) {
      this.usernameChange.emit(null);
      return;
    }
    this.usernameChange.emit(username);
  }
}
